module.exports = __webpack_public_path__ + "img/hcml_thumbnail.f43ed7ac.jpg";